class ContributorsList {
  constructor(element) {
    this.element = element;
    this.trigger = element.querySelector('.contributors-list__show-more');
    this.list = element.querySelector('.contributors-list__list');
    this.hiddenElements = element.querySelectorAll('.contributors-list__item[aria-hidden="true"]');
    this.expanded = false;
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.toggleExpanded());
    }
  }

  toggleExpanded() {
    const newExpanded = !this.expanded;
    this.expanded = newExpanded;
    this.list.setAttribute('aria-expanded', newExpanded);
    this.hiddenElements.forEach((elem) => {
      elem.setAttribute('aria-hidden', !newExpanded);
    });
  }
}

export default ContributorsList;
